/**
* 页面组件化
*/
const frontEndDIYComponent = {

  getFrontEndDIYComponentGroups: "/api/getFrontEndDIYComponentGroups",//查询自定义页面组件组
  getFrontEndDIYComponent: "/api/getFrontEndDIYComponent",//查询自定义页面组件
  getFrontEndDIYComponent2: "/api/getFrontEndDIYComponent2",//查询自定义页面组件
  createFrontEndDIYPage: "/api/createFrontEndDIYPage",//创建自定义页面
  modifyFrontEndDIYPageName: "/api/modifyFrontEndDIYPageName",//修改自定义页面显示名称
  modifyFrontEndDIYPageContent: "/api/modifyFrontEndDIYPageContent",//修改自定义页面内容
  getFrontEndDIYPages: "/api/getFrontEndDIYPages",//获取自定义页面
  getFrontEndDIYPageContent: "/api/getFrontEndDIYPageContent",//获取自定义页面内容
  getFrontEndDIYPageContent2: "/api/getFrontEndDIYPageContent2",//获取自定义页面内容
  deleteFrontEndDIYPage: "/api/deleteFrontEndDIYPage",//删除自定义页面
  copyFrontEndDIYPages: "/api/copyFrontEndDIYPages",//复制自定义页面
  getFrontEndDIYPages2: '/api/getFrontEndDIYPages2',//
}

export default frontEndDIYComponent